(function () {
  function normalizeQuantity(input) {
    if (!input) return 1;
    var value = parseInt(input.value, 10);
    if (!Number.isFinite(value) || value < 1) value = 1;
    input.value = String(value);
    return value;
  }

  function initQuantityControls(scope) {
    var root = scope || document;
    var controls = root.querySelectorAll("[data-product-quantity]");
    controls.forEach(function (control) {
      if (control.dataset.quantityInitialized === "true") return;
      control.dataset.quantityInitialized = "true";

      var input = control.querySelector("[data-product-qty-input]");
      var minus = control.querySelector("[data-product-qty-minus]");
      var plus = control.querySelector("[data-product-qty-plus]");

      if (!input) return;
      normalizeQuantity(input);

      if (minus) {
        minus.addEventListener("click", function () {
          input.value = String(Math.max(1, normalizeQuantity(input) - 1));
        });
      }

      if (plus) {
        plus.addEventListener("click", function () {
          input.value = String(normalizeQuantity(input) + 1);
        });
      }

      input.addEventListener("change", function () {
        normalizeQuantity(input);
      });

      input.addEventListener("blur", function () {
        normalizeQuantity(input);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initQuantityControls(document);
    });
  } else {
    initQuantityControls(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initQuantityControls(event.target);
  });
})();
